import { createFileRoute } from '@tanstack/react-router';
import { CrmPreviewPage } from '@/pages/Crm/CrmPreviewPage';
import { AclRoute, withPermission } from '@/lib/acl';
import { crmNavItem } from '@/lib/crm/crm-nav';

function Preview() {
  return <CrmPreviewPage navId="leads" />;
}

export const Route = createFileRoute('/crm/leads')({
  component: withPermission(Preview, { key: crmNavItem('leads').access, route: AclRoute.CRM, resourceLabel: 'Leads' }),
});
